import React from 'react'
import './styles.css'

export const PreviewBase = ({ children }) => (
  <div className="previewContainer">{children}</div>
)
